import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function ArticlesSection() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="text-xs text-foreground-500 font-medium tracking-widest uppercase mb-2">
            Artigos e Guias
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Aprenda Mais Sobre{' '}
            <span className="italic font-normal text-accent-600">Hoobuy Sheet</span>
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-xl">
            Guias completos, comparações e tutoriais para maximizar suas compras internacionais da China com o Hoobuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {articles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group cursor-pointer rounded-xl overflow-hidden bg-background-100 hover:bg-background-200/70 transition-all duration-300"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5">
                <span className="inline-block text-xs text-accent-600 font-medium uppercase tracking-wider mb-2">
                  {article.category}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-accent-600 transition-colors line-clamp-2">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                  {article.metaDescription}
                </p>
                <div className="flex items-center gap-1 mt-3 text-xs text-accent-600 font-medium">
                  Ler artigo
                  <span className="w-3 h-3 flex items-center justify-center">
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 text-sm font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            Acessar Hoobuy Sheet Agora
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-up-line"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}